import { BUS_SEO_AD_CONTEXT_ID } from '../constants/adsConfig';
export const ifAdsPresent = (): boolean => {
  const adsElement = document.getElementById(BUS_SEO_AD_CONTEXT_ID); //if an add is present in the SEO page
  return adsElement != null ? true : false;
};
